'use client';
import { GREY_800, GREY_1000, PURPLE_700 } from '@mnd-frontend/ui/shared/tokens';
import { memo } from 'react';
import styled from 'styled-components';
import { withComponentsContext } from '../../context';

const BarChartTabsWrapper = styled.div`
  display: flex;
  place-content: center;
`;

const Tab = styled.button`
  color: ${GREY_800};
  display: inline-block;
  padding: 1rem 0.7rem;
  position: relative;
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0em;
  cursor: pointer;
  appearance: none;
  background: none;
  border: none;

  &:focus-visible,
  &:hover {
    color: ${GREY_1000};
    outline: none;
  }

  &[aria-selected] {
    color: ${PURPLE_700};
  }


  &[aria-selected]:after {
    box-shadow: inset 0px -4px 0px 0px ${PURPLE_700};
    content: '';
    display: block;
    height: 100%;
    left: 0.5rem;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: calc(100% - 1rem);
  }
`;

interface Props {
  tabs: { value: string; label: string }[];
  selectedTab: string;
  onClick: (tab: string) => void;
  tabPanelId: string;
}

const BarChartTabs = ({ tabs, selectedTab, tabPanelId, onClick }: Props) => {
  return (
    <BarChartTabsWrapper>
      {tabs.map(tab => (
        <Tab
          key={tab.value}
          role="tab"
          aria-controls={tabPanelId}
          aria-selected={tab.value === selectedTab ? true : undefined}
          onClick={() => onClick(tab.value)}
        >
          {tab.label.slice(0, 3)}
        </Tab>
      ))}
    </BarChartTabsWrapper>
  );
};

export default memo(withComponentsContext(BarChartTabs, 'BarChartTabs'));
